import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from '@vectord/components';

import {
  isSbatGroupBulkUpdateFilterModalOpenSelector,
  setSbatGroupBulkUpdateFilterModalState,
} from 'features/classCreation';
import FilterDrawerContent from '../FilterDrawerContent';
import HideBodyScroll from 'components/HideBodyScroll';
import styles from './FilterDrawer.module.scss';

function FilterDrawer() {
  const dispatch = useDispatch();
  const isModalOpen = useSelector(isSbatGroupBulkUpdateFilterModalOpenSelector);

  const handleModalClose = useCallback(() => {
    dispatch(setSbatGroupBulkUpdateFilterModalState(false));
  }, [dispatch]);

  return (
    <Modal
      isOpen={isModalOpen}
      onClose={handleModalClose}
      position="right"
      unMountOnClose
      withoutHeader
      className={styles.root}
      containerClassName={styles.containerClassName}
      hasCloseButton={false}
      size="large"
    >
      <FilterDrawerContent />
      {isModalOpen && <HideBodyScroll />}
    </Modal>
  );
}

export default FilterDrawer;
